import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as suggestionsActions from '../../../redux/actions/SuggestionsActions';
import { createRecipient, getRecipientAccountDetails, getOrganizations } from '../../../redux/actions/RecipientAccountsActions';
import { getSystemSettings } from '../../../redux/actions/SettingsActions';

import Modal from '../../commonComponents/util/Modal';
import CreateRecipient from '../../applicationsComponents/newApplication/CreateRecipient';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import { RecipientTypes } from '../../../lib/systemVariables';
import { getLocationDepartment, locationIsIsraeli, validateAddressLocation } from '../../../lib/utils';

class CreateCampaignRecipientModal extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            modals: {
                address: false,
                warning: false
            },
            submitAttempted: false,
            error: false,
            dataErrors: {
                email: false,
                phoneNumber: false,
                secondPhoneNumber: false,
            },
            showEmail: false,
            showSecondPhone: false,
            showPrevAddress: false,
            setTrustedPayee: false,
            noSuggestions: false,
            recipient: {
                id: 0,
                fullName: '',
                applicantType: this.props.recipientType || RecipientTypes.Individual,
                isIsraeli: locationIsIsraeli(this.props.utils.locationGroups, this.props.locationId),
                personTitleId: null,
                firstName: '',
                lastName: '',
                reportName: '',
                organization: {
                    institutionTitleId: null,
                    name: '',
                    registered: true,
                    taxId: ''
                },
                address: {},
                previousAddress: {},
                teudatZehut: '',
                phoneNumber: '',
                secondPhoneNumber: '',
                email: '',
                bankRoutingNumber: '',
                bankBranchNumber: '',
                bankAccountNumber: '',
                bankAccountHolder: '',
                bankAccounts: [],
                tags: this.props.campaignTagId ? [this.props.campaignTagId] : [],
                note: '',
                references: [],
                solicitors: [],
                roshYeshivas: [],
                trustedPayee: ''
            }
        };

        this.state = this.initialState;

        this.onChange = this.onChange.bind(this);
        this.updateDataErrors = this.updateDataErrors.bind(this);
        this.getMissingFields = this.getMissingFields.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.locationId !== this.props.locationId) {
            const isIsraeli = locationIsIsraeli(this.props.utils.locationGroups, nextProps.locationId);
            this.initialState = { ...this.initialState, recipient: { ...this.initialState.recipient, isIsraeli } };
            this.setState({ recipient: { ...this.state.recipient, isIsraeli } });
        } else if (nextProps.campaignTagId !== this.props.campaignTagId) {
            this.initialState = { ...this.initialState, recipient: { ...this.initialState.recipient, tags: nextProps.campaignTagId ? [nextProps.campaignTagId] : [] } };
            this.setState({ recipient: { ...this.state.recipient, tags: nextProps.campaignTagId ? [nextProps.campaignTagId] : [] } });
        }
    }

    updateDataErrors(name, val) {
        this.setState({ dataErrors: { ...this.state.dataErrors, [name]: val } });
    }

    onChange(name, value) {
        this.setState({ [name]: value });
    }

    close() {
        this.props.close();

        this.setState(this.initialState);
        if (this.props.recipientSuggestions.data.length) this.props.actions.clearRecipientSuggestions();
    }

    getMissingFields() {
        if (!this.state.recipient.id) {
            if (this.state.recipient.isIsraeli) {
                if (this.state.recipient.applicantType === RecipientTypes.Individual && !this.state.recipient.teudatZehut) return true;
                if (!this.state.recipient.trustedPayee 
                        && (!this.state.recipient.bankRoutingNumber || !this.state.recipient.bankBranchNumber || !this.state.recipient.bankAccountNumber)) return true;
            }
            if (this.state.recipient.applicantType === RecipientTypes.Individual) {
                if (!this.state.recipient.firstName || !this.state.recipient.lastName) return true;
            } else {
                if (!this.state.recipient.organization.name) return true;
                if (this.state.recipient.organization.registered && !this.state.recipient.organization.taxId) return true;
            }
            if (!this.state.recipient.tags.length) return true;
            if (!this.state.recipient.address.streetNumber || !this.state.recipient.address.street || !this.state.recipient.address.city || !this.state.recipient.address.country) return true;
            if(this.state.setTrustedPayee && !this.state.recipient.trustedPayee) return true;
        }
        return false;
    }

    async saveOrContinue() {
        if (this.state.error) this.setState({ error: false });

        if (this.state.recipient.id) {
            this.props.onContinue(this.state.recipient);
            this.close();
            return;
        }

        const missingFields = this.getMissingFields();
        if (!missingFields) {
            const recipient = { 
                ...this.state.recipient, 
                references: this.state.recipient.references.map(ref => ({ referenceId: ref.referenceId, relationship: ref.relationship })),
                solicitors: this.state.recipient.solicitors.map(ref => ({ referenceId: ref.referenceId, relationship: ref.relationship })),
                roshYeshivas: this.state.recipient.roshYeshivas.map(ref => ({ referenceId: ref.referenceId, relationship: ref.relationship })),
                trustedPayeeId: this.state.recipient.trustedPayee ? this.state.recipient.trustedPayee.referenceId : null,
                bankAccounts: this.state.recipient.bankAccounts,
            };

            await this.props.actions.createRecipient(recipient);

            if (this.props.createRecipient.success) {
                if (!this.state.recipient.id && (this.state.recipient.address.country && this.props.utils.nationalities.indexOf(this.state.recipient.address.country) < 0)) {
                    this.props.actions.getSystemSettings();
                } else if (!this.state.recipient.id && this.state.recipient.applicantType === RecipientTypes.Organization) this.props.actions.getOrganizations();

                await this.props.actions.getRecipientAccountDetails(this.props.createRecipient.data);
                this.props.onContinue(this.props.recipientDetails.data);
                this.close();
            } else {
                this.setState({ 
                    error: true
                });
            }
        } else {
            if (!this.state.submitAttempted) this.setState({ submitAttempted: true });
        }
    }

    render() {
        const { utils } = this.props;

        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal create-recipient-modal xl-modal">
                        <div className="modal-header">
                            <div>
                                <h4 className="page-header">Create Recipient</h4>
                                <p className="medium-text" />
                            </div>
                            <i className="icon ion-ios-close-empty" onClick={this.close.bind(this)} />
                        </div>
                        <CreateRecipient
                            tags={{
                                usPersonTitles: utils.usPersonTitles,
                                israelPersonTitles: utils.usPersonTitles,
                                usInstitutionTitles: utils.usInstitutionTitles,
                                israelInstitutionTitles: utils.israelInstitutionTitles,
                                recipientTypes: this.props.recipientType ?
                                    utils.recipientTypes.filter(type => type.value === this.props.recipientType)
                                    : utils.recipientTypes,
                                categories: {
                                    individualTags: utils.individualTags,
                                    organizationTags: utils.organizationTags
                                }
                            }}
                            campaignTagId={this.props.hasOwnProperty('campaignTagId') ? this.props.campaignTagId : null}
                            hideRecipientTitle={true}
                            departments={[getLocationDepartment(this.props.utils.locationGroups, this.props.locationId)]}
                            submitAttempted={this.state.submitAttempted}
                            recipient={this.state.recipient}
                            dataErrors={this.state.dataErrors} updateDataErrors={this.updateDataErrors}
                            clearIsraeliApplicationInfo={() => { }}
                            toggleModal={this.toggleModal} onChange={this.onChange}
                            suggestions={{
                                suggestions: this.props.recipientSuggestions.data,
                                getSuggestions: this.props.hasOwnProperty('getRecipientSuggestions') ? this.props.getRecipientSuggestions : undefined,
                                clearSuggestions: this.props.actions.clearRecipientSuggestions
                            }}
                            validateAddress={this.props.locationId ? validateAddressLocation.bind(this, this.props.utils.locationGroups, this.props.locationId) : null}
                            showSecondPhone={this.state.showSecondPhone}
                            showEmail={this.state.showEmail}
                            showPrevAddress={this.state.showPrevAddress}
                            setTrustedPayee={this.state.setTrustedPayee}
                            allowIncomplete={false} />

                        {this.props.createRecipient.loading || this.props.recipientDetails.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="application-create-btns modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.close.bind(this)}>Cancel</button>
                                <button className="btn btn-primary"
                                    disabled={Object.keys(this.state.dataErrors).some(k => this.state.dataErrors[k])}
                                    onClick={this.saveOrContinue.bind(this)}>{this.state.recipient.id ? 'Continue' : 'Save'}</button>
                                <FadeOutErrorMessage show={this.state.error}
                                    message={this.props.createRecipient.message || 'Something went wrong and the recipient could not be created. Please try again.'} />
                            </div>}

                    </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        recipientDetails: state.recipientAccountDetails.recipientDetails,
        createRecipient: state.recipientAccounts.createRecipient,
        utils: {
            usPersonTitles: state.settings.systemSettings.data.recipientSettings.usPersonTitles,
            israelPersonTitles: state.settings.systemSettings.data.recipientSettings.israelPersonTitles,
            usInstitutionTitles: state.settings.systemSettings.data.recipientSettings.usInstitutionTitles,
            israelInstitutionTitles: state.settings.systemSettings.data.recipientSettings.israelInstitutionTitles,
            recipientTypes: state.settings.systemSettings.data.otherSettings.recipientTypes,
            individualTags: state.settings.systemSettings.data.recipientSettings.individualTags,
            organizationTags: state.settings.systemSettings.data.recipientSettings.organizationTags,
            nationalities: state.settings.systemSettings.data.otherSettings.nationalities,
            locationGroups: state.settings.systemSettings.data.campaignSettings.locationGroups
        },
        ...state.suggestions
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...suggestionsActions,
            createRecipient,
            getRecipientAccountDetails,
            getSystemSettings,
            getOrganizations
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCampaignRecipientModal);



// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignsCommon/CreateCampaignRecipientModal.jsx